import { render, staticRenderFns } from "./location-drop-zones.vue?vue&type=template&id=2a53fc00&scoped=true"
import script from "./location-drop-zones.vue?vue&type=script&lang=js"
export * from "./location-drop-zones.vue?vue&type=script&lang=js"
import style0 from "./location-drop-zones.vue?vue&type=style&index=0&id=2a53fc00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a53fc00",
  null
  
)

export default component.exports